export default __webpack_public_path__ + "static/wireframe1-7a09349214af225ffc90778801f0172d.png";